module.exports = "https://d2jau2w7zc1e7m.cloudfront.net/packs/2273e3d8ad9264b7daa5bdbf8e6b47f8.png";